import { Component } from 'sane-ui'
import { gsap } from 'gsap'

class PageTransition extends Component {
  constructor ($el, args) {
    super($el, args)
    this.tl = gsap.timeline()
  }

  animateIn (callback) {
    this.tl
      .clear()
      .to(this.$el, { duration: 0.4, autoAlpha: 1, ease: 'none' })
      .call(callback, [], '+=0.1')
  }

  animateOut (callback) {
    const duration = window.innerWidth < 768 ? 0.4 : 0
    this.tl
      .clear()
      .to(this.$el, { duration, autoAlpha: 0, ease: 'none' })
      .call(callback, [], '+=0.1')
  }
}

export default PageTransition



// WEBPACK FOOTER //
// ./scripts/components/PageTransition.js